export default __webpack_public_path__ + "static/media/buyOneGetOneProduct.aa852374.webp";